<template>
  <section class="icons-list">
    <b-container>
      <b-row align-h="center">
        <b-col cols="12" xl="10">
          <b-container class="">
            <b-row class="icons-list__container mb-3 mb-md-0">
              <div v-for="(icon, index) in payload.icons" :key="index" class="d-flex text-center"
                     :class="getDisplayClass(icon.icon)">
                <div @click="activeIndex = index; active = 'active-'+index" :data-index="index" class="icon icons-list__box" :class="{ 'active': activeIndex === index }">
                  <img v-if="icon.icon === 'people'" src="../../assets/media/icons/spoleczenstwo.svg" alt="People icon" />
                  <img v-if="icon.icon === 'cog_ball'" src="../../assets/media/icons/sport-i-technologia.svg" alt="Cog ball icon" />
                  <img v-if="icon.icon === 'plant_2'" src="../../assets/media/icons/zrownowazone-sr-i-technologia.svg" alt="Plant 2 icon" />
                  <img v-if="icon.icon === 'cloud'" src="../../assets/media/icons/higiena-cyfrowa.svg" alt="Cloud icon" />
                </div>

                  <div v-if="icon.icon === 'heart'" @click="activeIndex = index; active = 'heart'" class="icon icons-list__box" :class="{ 'active-heart': activeIndex === index}">
                    <svg class="icon" width="41" height="42" viewBox="0 0 41 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_2984_6564)">
                        <path d="M19.8014 31.6242L27.9617 24.2513C29.2688 23.2011 30.0254 21.6485 30.0457 19.9886C30.0836 16.9025 27.5598 14.3602 24.4199 14.3217C22.6787 14.3003 21.0564 15.052 19.9701 16.334C18.9156 15.0257 17.3171 14.2344 15.5711 14.213C12.4312 14.1744 9.84563 16.654 9.80773 19.74C9.78729 21.4046 10.515 22.9802 11.7724 24.0385L19.8014 31.6242ZM11.235 19.7576C11.2634 17.443 13.2037 15.5869 15.5539 15.6157C17.1523 15.6354 18.5927 16.5182 19.313 17.9254L19.931 19.1301L20.5784 17.9409C21.333 16.5519 22.7946 15.7047 24.3931 15.7243C26.748 15.7532 28.6374 17.6611 28.609 19.9709C28.5938 21.21 28.0228 22.3768 27.0135 23.1922L19.8107 29.6976L12.732 22.9981C11.7666 22.1865 11.2196 21.006 11.235 19.7576Z" fill="#393947"/>
                        <path d="M39.1217 20.5725C38.5395 12.1851 32.492 5.20824 24.27 3.26471C24.1378 2.01913 23.0889 1.03353 21.7853 1.01753C20.3819 1.00029 19.2311 2.10853 19.2142 3.48322C19.1973 4.85791 20.3253 5.99413 21.724 6.0113C22.7183 6.02352 23.5816 5.46358 24.0104 4.64578C31.5962 6.47393 37.1649 12.9211 37.6979 20.6673C37.8796 23.3071 37.4767 25.8883 36.5046 28.3315L37.8354 28.8436C38.8812 26.2048 39.3198 23.423 39.1217 20.5725ZM21.7412 4.60856C21.1275 4.60102 20.634 4.10393 20.6414 3.50074C20.6488 2.89756 21.1544 2.41274 21.7681 2.42027C22.3818 2.42781 22.8753 2.92491 22.8679 3.52809C22.8605 4.13127 22.3549 4.61609 21.7412 4.60856Z" fill="#393947"/>
                        <path d="M34.6078 30.1224C33.2139 30.1053 32.0631 31.2089 32.0463 32.5789C32.0387 33.2008 32.2744 33.7649 32.6497 34.2044C29.542 37.3556 25.3934 39.2548 20.9218 39.5506C11.0074 40.2052 2.38134 32.8085 1.70652 23.0543C1.07577 13.9741 7.74291 5.75518 16.8815 4.34754L16.6607 2.96057C6.63057 4.50692 -0.408584 13.1843 0.282681 23.1491C0.97343 33.156 9.41955 40.8684 19.4529 40.9916C19.9715 40.998 20.495 40.9857 21.0236 40.9501C25.9428 40.6224 30.4937 38.5084 33.8677 34.9863C34.0858 35.0498 34.3088 35.0946 34.5467 35.0975C35.9406 35.1146 37.0914 34.0111 37.1082 32.6411C37.1251 31.2664 36.0017 30.1396 34.6078 30.1224ZM34.5639 33.6948C33.955 33.6873 33.4662 33.1949 33.4735 32.5964C33.4809 31.9979 33.9816 31.5177 34.5906 31.5252C35.1995 31.5327 35.6883 32.025 35.681 32.6235C35.6736 33.222 35.1729 33.7023 34.5639 33.6948Z" fill="#393947"/>
                        <path d="M15.4942 35.9721L15.57 35.9964C19.2828 37.0428 23.213 36.6514 26.6413 34.9024C33.9912 31.1439 36.8607 22.2096 33.0335 14.9841C29.2063 7.75393 20.1149 4.9299 12.765 8.68842C7.67041 11.2915 4.53671 16.5608 4.68653 22.1839C3.98919 22.3998 3.38355 22.8974 3.08451 23.6139C2.55973 24.8889 3.18412 26.3509 4.48151 26.8672C5.77889 27.3836 7.2662 26.7705 7.79103 25.4909C8.31581 24.216 7.69142 22.7539 6.39403 22.2376C6.29934 22.199 6.20437 22.1838 6.10956 22.1546C5.97229 17.0602 8.80964 12.2875 13.4207 9.93107C20.0715 6.52874 28.3049 9.08503 31.7647 15.6232C35.2292 22.1615 32.6318 30.2527 25.9811 33.6503C22.8783 35.235 19.3197 35.5888 15.9768 34.6452L15.9152 34.6257C12.5829 33.5934 9.81246 31.3661 8.1174 28.3616L6.87192 29.0431C8.54841 32.0099 11.1754 34.2916 14.3478 35.5605C14.7218 35.7147 15.1055 35.8504 15.4942 35.9721ZM6.46998 24.9649C6.23949 25.5233 5.58903 25.7959 5.02084 25.5691C4.45265 25.3423 4.17502 24.7029 4.40551 24.1446C4.636 23.5862 5.28645 23.3136 5.85464 23.5404C6.42759 23.7672 6.70046 24.4066 6.46998 24.9649Z" fill="#393947"/>
                      </g>
                      <defs>
                        <clipPath id="clip0_2984_6564">
                          <rect width="40" height="40" fill="white" transform="translate(0.491211 0.755859) rotate(0.703593)"/>
                        </clipPath>
                      </defs>
                    </svg>
                    <h6 class="icons-list__box-title">Zdrowie</h6>
                  </div>
                  <div class="icon icons-list__box" @click="activeIndex = index; active = 'shield'" v-if="icon.icon === 'shield'" :class="{ 'active-shield': activeIndex === index}">
                    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_2991_8425)">
                        <path d="M20.4065 27.5492L17.9579 17.2785C19.3389 16.4419 20.2057 14.936 20.2057 13.2873C20.2057 10.7184 18.1244 8.63184 15.573 8.63184C13.0167 8.63184 10.9403 10.7234 10.9403 13.2873C10.9403 14.936 11.8022 16.4468 13.1881 17.2785L10.7395 27.5492H20.4065ZM14.3193 16.2106C13.1538 15.7086 12.4045 14.562 12.4045 13.2873C12.4045 11.5354 13.8247 10.1082 15.5681 10.1082C17.3115 10.1082 18.7317 11.5354 18.7317 13.2873C18.7317 14.557 17.9775 15.7086 16.8169 16.2106L16.2488 16.4566L18.5407 26.0728H12.5955L14.8874 16.4566L14.3193 16.2106Z" fill="#393947"/>
                        <path d="M30.3967 21.3831L26.2831 16.4077L25.1519 17.3526L29.7062 22.8595H31.0823L40 12.9628L38.9129 11.9736L30.431 21.3831H30.3967Z" fill="#393947"/>
                        <path d="M29.6719 24.8474C29.6719 25.3051 29.6425 25.7628 29.5935 26.2008L29.5544 26.5108C29.4368 27.3081 29.2262 28.061 28.9471 28.7697C28.8834 28.9321 28.8149 29.0896 28.7414 29.247C28.6827 29.375 28.6239 29.498 28.5651 29.6211C28.4917 29.7687 28.4133 29.9213 28.3301 30.064C28.2811 30.1526 28.2272 30.2411 28.1734 30.3297C28.0656 30.5069 27.953 30.6841 27.8355 30.8563C27.8012 30.9055 27.7669 30.9547 27.7326 31.0039C27.5906 31.2008 27.4437 31.3976 27.2919 31.5945C27.2527 31.6437 27.2135 31.6929 27.1743 31.7421C26.998 31.9587 26.8168 32.1703 26.621 32.377C26.621 32.377 26.621 32.3819 26.6161 32.3819C26.4104 32.6033 26.1949 32.815 25.9647 33.0315C25.95 33.0463 25.9305 33.061 25.9158 33.0807C25.6905 33.2923 25.4505 33.499 25.2057 33.7057C25.191 33.7205 25.1763 33.7303 25.1567 33.7451C24.6572 34.1585 24.1136 34.5522 23.5309 34.936C23.5113 34.9508 23.4868 34.9655 23.4672 34.9754C23.1929 35.1526 22.9089 35.3248 22.62 35.497C22.571 35.5266 22.522 35.5512 22.478 35.5807C22.1988 35.7431 21.9148 35.9006 21.621 36.0532C21.5573 36.0876 21.4985 36.1171 21.4349 36.1516C21.1508 36.2992 20.857 36.4468 20.5534 36.5846C20.4848 36.6191 20.4114 36.6486 20.3428 36.6831C20.0441 36.8209 19.7404 36.9587 19.427 37.0915C19.3536 37.1211 19.2801 37.1506 19.2116 37.1801C18.8932 37.313 18.57 37.4409 18.237 37.5689C18.1685 37.5935 18.1048 37.6181 18.0362 37.6427C17.6885 37.7707 17.331 37.8986 16.9638 38.0217C16.9197 38.0364 16.8707 38.0512 16.8266 38.0709C16.4153 38.2087 15.999 38.3415 15.573 38.4695C15.3771 38.4104 15.1812 38.3514 14.9853 38.2874C14.9314 38.2677 14.8727 38.253 14.8188 38.2333C14.6817 38.189 14.5446 38.1447 14.4025 38.1004C14.3144 38.0709 14.2311 38.0413 14.143 38.0118C14.0353 37.9774 13.9275 37.938 13.8247 37.9035C13.7218 37.8691 13.619 37.8297 13.5162 37.7904C13.428 37.7559 13.335 37.7264 13.2468 37.6919C13.1293 37.6476 13.0167 37.6033 12.8991 37.564C12.8208 37.5345 12.7473 37.5049 12.669 37.4754C12.5416 37.4262 12.4143 37.377 12.287 37.3228C12.2233 37.2982 12.1596 37.2687 12.096 37.2441C11.9589 37.19 11.8217 37.1309 11.6846 37.0718C11.6308 37.0522 11.5818 37.0276 11.5279 37.0079C11.381 36.9439 11.2341 36.8799 11.0872 36.8159C11.0529 36.8012 11.0186 36.7815 10.9794 36.7667C10.8178 36.6929 10.6562 36.6191 10.4995 36.5453C10.4848 36.5404 10.4701 36.5305 10.4554 36.5256C9.35847 35.999 8.28599 35.4035 7.29187 34.7244C7.27718 34.7146 7.26739 34.7047 7.25269 34.6998C7.11557 34.6063 6.98335 34.5128 6.85113 34.4144C6.81195 34.3848 6.76787 34.3553 6.7287 34.3258C6.61117 34.2421 6.49853 34.1535 6.3859 34.065C6.32713 34.0207 6.27326 33.9764 6.21939 33.9321C6.12145 33.8533 6.01861 33.7697 5.92067 33.6909C5.85211 33.6368 5.78844 33.5778 5.71988 33.5236C5.63173 33.4498 5.54848 33.376 5.46523 33.2972C5.39177 33.2283 5.31342 33.1594 5.23996 33.0905C5.1665 33.0217 5.09305 32.9528 5.01959 32.8839C4.93634 32.8051 4.85309 32.7215 4.77473 32.6378C4.71596 32.5787 4.6523 32.5148 4.59354 32.4508C4.50049 32.3524 4.41234 32.2539 4.32419 32.1555C4.28012 32.1063 4.23115 32.0522 4.18707 31.998C4.08423 31.8799 3.98629 31.7618 3.88834 31.6388C3.85896 31.6043 3.82958 31.565 3.8002 31.5305C3.68266 31.3829 3.57003 31.2303 3.46229 31.0778C3.4476 31.063 3.43781 31.0482 3.42801 31.0384C2.69833 30.0049 2.14496 28.8583 1.81195 27.5886C1.80705 27.5738 1.80705 27.5591 1.80215 27.5443C1.75318 27.3573 1.70911 27.1654 1.67483 26.9734C1.66503 26.9291 1.66014 26.8848 1.65034 26.8406C1.53281 26.2008 1.46915 25.5413 1.46915 24.8474V4.95571L15.5681 1.51575L29.667 4.95571V17.7657H31.1361V3.79429L15.5681 0L0 3.79429V24.8474C0 25.4872 0.0440744 26.1171 0.13712 26.7274V26.7323C0.190989 27.0866 0.259549 27.436 0.342801 27.7805C0.347698 27.8051 0.352596 27.8297 0.36239 27.8543C0.450539 28.1988 0.553379 28.5433 0.666014 28.878C0.670911 28.8927 0.675808 28.9026 0.680705 28.9173C2.15475 33.1152 6.02351 36.4813 12.1009 38.8337C12.1352 38.8484 12.1694 38.8583 12.2037 38.873C12.6787 39.0551 13.1636 39.2323 13.6631 39.3996C13.712 39.4144 13.761 39.4291 13.81 39.4488C14.3095 39.6161 14.8237 39.7785 15.3526 39.936C15.3575 39.936 15.3624 39.9409 15.3673 39.9409L15.573 40L15.7786 39.9409C15.7933 39.936 15.808 39.9311 15.8178 39.9262C16.3467 39.7687 16.8609 39.6063 17.3604 39.439C17.4584 39.4045 17.5514 39.3701 17.6445 39.3406C18.0852 39.188 18.5211 39.0305 18.9422 38.873C18.9863 38.8533 19.0353 38.8386 19.0793 38.8189C25.0245 36.5157 28.8198 33.2825 30.3722 29.1585L30.3624 29.1535C30.6611 28.3661 30.8815 27.5591 31.0088 26.7126L31.0529 26.3829C31.1117 25.8809 31.1459 25.3642 31.1459 24.8474V24.5768H29.6768V24.8474H29.6719Z" fill="#393947"/>
                      </g>
                      <defs>
                        <clipPath id="clip0_2991_8425">
                          <rect width="40" height="40" fill="white"/>
                        </clipPath>
                      </defs>
                    </svg>
                    <h6 class="icons-list__box-title">Bezpieczeństwo</h6>
                  </div>
                  <div class="icon icons-list__box" @click="activeIndex = index; active = 'plant'" v-if="icon.icon === 'plant'" :class="{ 'active-plant': activeIndex === index }">
                    <svg width="39" height="40" viewBox="0 0 39 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_2991_8441)">
                        <path d="M19.6333 40.0116H18.1367V9.51018C18.1367 4.32719 22.4718 0.11084 27.7897 0.11084H38.8644V3.44797C38.8494 9.93279 33.4268 15.2032 26.767 15.2032C24.6868 15.2032 22.6664 14.698 20.8854 13.7411L21.6088 12.4684C23.1652 13.3088 24.9362 13.7508 26.7321 13.7508C32.6137 13.7508 37.3678 9.12158 37.3678 3.42854V1.5681H27.7897C23.2899 1.5681 19.6333 5.12868 19.6333 9.51018V40.0116Z" fill="#393947"/>
                        <path d="M16.323 40.1413H14.8427V15.6043C14.8427 12.5219 12.0942 10.0156 8.71417 10.0156H1.48526V11.208C1.48526 15.2398 5.08244 18.5157 9.49874 18.5157C10.8804 18.5157 12.2176 18.2007 13.3969 17.6067L14.1124 18.7857C12.716 19.4921 11.1271 19.8611 9.52341 19.8611C4.26827 19.8611 0.00986882 15.9868 0 11.2215V8.66113H8.70923C12.9035 8.66113 16.3181 11.775 16.3181 15.5998V31.4616L16.323 40.1413Z" fill="#393947"/>
                      </g>
                      <defs>
                        <clipPath id="clip0_2991_8441">
                          <rect width="38.8644" height="40" fill="white"/>
                        </clipPath>
                      </defs>
                    </svg>
                    <h6 class="icons-list__box-title">Klimat</h6>
                  </div>
                  <div class="icon icons-list__box" @click="activeIndex = index; active = 'integration'" v-if="icon.icon === 'integration'" :class="{ 'active-integration': activeIndex === index }">
                    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_2991_8456)">
                        <path d="M4.41919 25.4047C4.41919 29.2028 5.88093 32.8005 8.53134 35.5369C11.1536 38.2452 14.6594 39.8198 18.4061 39.984V40H19.5908L19.6912 39.988C23.4419 39.8198 26.9477 38.2452 29.566 35.5369C32.2164 32.8005 33.6781 29.2028 33.6781 25.4047V24.7637H4.41919V25.4047ZM5.7203 26.0457H18.4101V38.706C11.5914 38.3815 6.04558 32.8486 5.7203 26.0457ZM19.6952 38.706V26.0457H32.385C32.0598 32.8486 26.514 38.3815 19.6952 38.706Z" fill="#393947"/>
                        <path d="M16.1292 6.979H15.4866C7.41895 6.979 0.857178 13.5255 0.857178 21.5744V22.2154H16.1292V6.979ZM14.8441 8.27708V20.9373H2.15829C2.48357 14.1345 8.02935 8.6016 14.8481 8.27708H14.8441Z" fill="#393947"/>
                        <path d="M24.3854 0H23.7429V15.2364H39.0149V14.5954C39.0149 6.54647 32.4531 0 24.3854 0ZM25.028 13.9543V1.29808C31.8468 1.6226 37.3925 7.15545 37.7178 13.9583H25.028V13.9543Z" fill="#393947"/>
                      </g>
                      <defs>
                        <clipPath id="clip0_2991_8456">
                          <rect width="40" height="40" fill="white"/>
                        </clipPath>
                      </defs>
                    </svg>
                    <h6 class="icons-list__box-title">Integracja</h6>
                  </div>
      <!--          <h6 :class="{...getActiveClass(icon.icon), ...getDisplayClass(icon)}" class="d-md-block">{{icon.name }} </h6>-->
              </div>
            </b-row>
          </b-container >
          <b-container class="icons-list__list" :class="{...getActiveClass(active), 'first': this.activeIndex === 0}">
            <div class="icons-list__list-swiper swiper">
              <div class="swiper-wrapper">
                <expandable-item v-for="(content,i) in activeContent" :key="i" :payload="content" :color-index="activeIndex"/>
              </div>
              <div class="icons-list__nav">
                <div class="d-flex">
                  <div class="icons-list__nav-arrows">
                    <svg class="icons-list__nav-left" width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M20 8.42871L12 16.4287L20 24.4287" stroke="#111111" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <svg class="icons-list__nav-right" width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12 8.42871L20 16.4287L12 24.4287" stroke="#111111" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </b-container>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>
import ExpandableItem from "../utility/ExpandableItem";
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import 'swiper/swiper-bundle.min.css';
export default {
  name: "IconsContentList",
  components: {ExpandableItem},
  props: ['payload'],
  data() {
    return {
      activeIndex: 0,
      active: 'index-0',
    }
  },
  methods: {
    getActiveClass(icon) {
      switch(icon) {
        case 'heart': return {'active-heart': this.activeIndex === 0};
        case 'shield': return {'active-shield': this.activeIndex === 1};
        case 'plant': return {'active-plant': this.activeIndex === 2};
        case 'integration': return {'active-integration': this.activeIndex === 3};
        default: return {'active': true }
      }
    },
    getDisplayClass(icon) {
      switch(icon) {
        case 'heart': return {'d-none': this.activeIndex !== 0};
        case 'shield': return {'d-none': this.activeIndex !== 1};
        case 'plant': return {'d-none': this.activeIndex !== 2};
        case 'integration': return {'d-none': this.activeIndex !== 3};
      }
    }
  },
  mounted() {
    this.swiper = new Swiper('.icons-list__list-swiper', {
      modules: [Navigation],
      slidesPerView: 'auto',
      loop: false,
      spaceBetween: 24,
      centeredSlides: true,
      breakpoints: {
        576: {
          centeredSlides: false,
          slidesPerView: 'auto'
        },
      },
      navigation: {
        nextEl: '.icons-list__nav-right',
        prevEl: '.icons-list__nav-left',
      },
    });
  },
  computed: {
    activeContent() {
      return this.payload.icons[this.activeIndex].content
    },
  }
}
</script>

<style scoped lang="scss">
img {
  height: 3rem;
}

.icons-list__container svg {
  cursor: pointer;
  width: 40px;
  height: 40px;

  @include media-breakpoint-down(lg){
    width: 20px;
    height: 20px;
  }
}

.icons-list__box {
  &.active {
    background-color: $safety-yellow !important;

    svg path {
      fill: $main-color;
    }
  }
}

.icons-list__list {
  &.active {
    background-color: $safety-yellow !important;
  }
  &.first {
    border-top-left-radius: 0;
  }
}

.active {
  &-heart{
    background-color: $safety-yellow;
    svg path {
      fill: $main-color;
    }
  }
  &-shield{
    background-color: $health-red;
    color: $white;
    svg path {
      fill: $white;
    }
  }
  &-plant{
    background-color: $climate-blue;
    color: $white;
    svg path {
      fill: $white;
    }
  }
  &-integration{
    background-color: $safety-yellow;
    svg path {
      fill: $main-color
    }
  }
}

.icons-list {
  position: relative;
  background: $main-bg;
  color: $main-color;
  padding-top: 70px;
  padding-bottom: 70px;

  &__container {
    display: flex;
    align-items: center;
    gap: 16px;

    @include media-breakpoint-down(xs){
      flex-direction: column;
    }
  }

  &__box {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 8px 24px;
    border-radius: 16px 16px 0px 0px;
    cursor: pointer;

    @include media-breakpoint-down(sm){
      border-radius: 16px;
    }

    &-title {
      font-size: 1.25em;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      margin: 0;

      @include media-breakpoint-down(lg){
        font-size: .85em;
      }
    }
  }

  &__list {
    position: relative;
    padding: 40px;
    border-radius: 16px 16px 16px 16px;
    z-index: 2;

    @include media-breakpoint-down(lg){
      padding: 20px;
    }

    &.active-heart {
      border-radius: 0px 16px 16px 16px;

      @include media-breakpoint-down(sm){
        border-radius: 16px;
      }
    }
  }

  &__nav {
    //position: absolute;
    //bottom: 64px;
    //right: 64px;
    margin-top: 32px;
    display: flex;
    justify-content: flex-end;
  }

  .icons-list__nav-left,
  .icons-list__nav-right,
  .icons-list__nav-pause {

    &:hover {
      cursor: pointer;
    }
  }

  .icons-list__nav-left path {
    fill: none!important;
  }

  .icons-list__nav-right path {
    fill: none!important;
  }
}
</style>
